// extracted by mini-css-extract-plugin
module.exports = {"heading":"Heading_heading__QQE7J","h1":"Heading_h1__2_xYj","h2":"Heading_h2__nBT7O","h3":"Heading_h3__AlVzG","h4":"Heading_h4__4nqAN","h5":"Heading_h5__TFUdJ","h6":"Heading_h6__F5q_g","gradient":"Heading_gradient__s1e09"};
module.exports.__checksum = "2d228095a132"
